import React, { Component } from 'react';
import SideMenuOcean from '../../components/SideMenuOcean/SideMenuOcean';
import OceanBg from '../../components/OceanBg/OceanBg';
import styled from 'styled-components';
import InfoAquaticlife from '../../components/InfoAquaticlife/InfoAquaticlife';
import InfoInvasivespecies from '../../components/InfoInvasivespecies/InfoInvasivespecies';
import InfoAcidification from '../../components/InfoAcidification/InfoAcidification';
import InfoSealevel from '../../components/InfoSealevel/InfoSealevel';
import InfoOceanwarming from '../../components/InfoOceanwarming/InfoOceanwarming';
import InfoOverfishing from '../../components/InfoOverfishing/InfoOverfishing';
import InfoHypoxia from '../../components/InfoHypoxia/InfoHypoxia';
import InfoPollution from '../../components/InfoPollution/InfoPollution';
import AskOceans from '../../components/AskOceans/AskOceans';
import {Link} from 'react-router-dom';

const Tree = styled.p`
  display:flex;
  flex-direction:row;
  flex-wrap:wrap;
  font-family:roboto;
  font-size: 1.5rem;
  font-weight:300;
  color: #ffffff;
  margin: 0em 0em 0.9em;
  letter-spacing: .6px;
  margin-left:0px;
  
`;

const Stacker= styled.div`
  display: flex;
  flex-direction:row;
  height: auto;
  justify-content: space-around;
  margin-top:64px;
  @media (max-width: 1130px) {
    flex-direction: column;
  }
`;
const Left = styled.div`
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  display:flex;
  justify-content:center;
`;

const Threat = styled.div`
    width:40vw;
  align-self:center;
  @media (max-width: 1130px) {
    width:85%;
  }
   @media (max-width: 768px) {
    width:100%;
  }
`;

const Right = styled.div`
    display:flex;
  justify-content:center;
`;

const Impacts = styled.div`
  width:40vw;
  flex-direction:column;
  justify-content:center;

    @media (max-width: 1130px) {
    width:85%;
  }
   @media (max-width: 768px) {
    width:100%;
  }
`;

const Contentwrapper = styled.div`
  margin-left:15px;
  margin-top:15px;
  margin-right:15px;
  margin-bottom:15px;

`;

const Impactwrapper = styled.div`
  margin-left:0px;
  margin-top:15px;
  margin-right:0px;
  margin-bottom:15px;
    transform: scale(1);
  transition: all 0.5s;
      &:hover {
  transform: scale(1.04);
    transition: all 0.5s;
  
}
`;


class Oceans extends Component{



askearth= ()=> {
          window.dexterApi.open();
          window.dexterApi.replyTo('why are the oceans important');
        }

  render(){



    return(
      
        <body> 

          <SideMenuOcean />
          <OceanBg/>
          

          <Stacker>
            
      <Contentwrapper>
          <Left>
           <Threat>  
           <Contentwrapper>
          <Tree>Oceans/</Tree>         
          </Contentwrapper>        
              <Impactwrapper><Link onClick={this.askearth}><AskOceans/></Link></Impactwrapper>
           </Threat>
          </Left>
      </Contentwrapper>
     
      <Contentwrapper>
          <Right>
           <Impacts>
 
              <Impactwrapper><Link to="/Oceans_Aquatic-life"><InfoAquaticlife/></Link></Impactwrapper>
              <Impactwrapper><Link to="/Oceans_Invasive-species"><InfoInvasivespecies/></Link></Impactwrapper>
              <Impactwrapper><Link to="/Oceans_Acidification"><InfoAcidification/></Link></Impactwrapper> 
               
              <Impactwrapper><Link to="/Oceans_Overfishing"><InfoOverfishing/></Link></Impactwrapper> 
              <Impactwrapper><Link to="/Oceans_Plastic-pollution"><InfoPollution/></Link></Impactwrapper>   
              <Impactwrapper><Link to="/Oceans_Warming"><InfoOceanwarming/></Link></Impactwrapper> 
              <Impactwrapper><Link to="/Oceans_Sea-level"><InfoSealevel/></Link></Impactwrapper>
                    
              <Impactwrapper><Link to="/Oceans_Hypoxia"><InfoHypoxia/></Link></Impactwrapper> 
              
           </Impacts>
          </Right> 
      </Contentwrapper>

      </Stacker>
                  
        </body>
      
      );

  } 
}

export default Oceans;